import {
  Tab as RACTab,
  TabList as RACTabList,
  type TabListProps as RACTabListProps,
  TabPanel as RACTabPanel,
  type TabPanelProps as RACTabPanelProps,
  type TabProps as RACTabProps,
  Tabs as RACTabs,
  type TabsProps as RACTabsProps,
  SelectionIndicator,
} from "react-aria-components";

export { SelectionIndicator };

export interface TabsProps extends RACTabsProps {}
export interface TabListProps<T extends object> extends RACTabListProps<T> {}
export interface TabProps extends RACTabProps {}
export interface TabPanelProps extends RACTabPanelProps {}

export function Tabs(props: TabsProps) {
  return <RACTabs {...props} />;
}

export function TabList<T extends object>(props: TabListProps<T>) {
  return <RACTabList {...props} />;
}

export function Tab(props: TabProps) {
  return <RACTab {...props} />;
}

export function TabPanel(props: TabPanelProps) {
  return <RACTabPanel {...props} />;
}
